import React, { useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import { useHistory } from 'react-router-dom';
import { useGetBenefitQuery } from '../../apis/cmsApi/cms.hooks.api';
import { Button } from '../../components/Button/Button';
import { BaseLayout } from '../../components/Layout/Layout';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';
import { Routes } from '../../routes/types';

import './KnowServicesView.css';

type KnowServicesViewProps = {};

export const KnowServicesView: React.FC<KnowServicesViewProps> = () => {
  const languageSettings = useLanguage();
  const history = useHistory();
  const t = languageSettings[0];
  const locale = languageSettings[2];
  const back = useBack();

  const goToSignIn = useCallback(() => {
    history.push(Routes.SignIn);
  }, [history]);
  
  const goToSignUp = useCallback(() => {
    history.push(Routes.SignUp);
  }, [history]);

  const { data: benefit } = useGetBenefitQuery({
    locale,
  });

  return (
    <BaseLayout hasBack onBackClick={back} title={t('pageTitles.benefits')}>
      {benefit && <ReactMarkdown>{benefit.content}</ReactMarkdown>}
      <div className='know-services--button'>
        <Button onClick={goToSignIn} isPrimary label={t('signInView.signIn')} />
      </div>
      <div className='know-services--secondary-button'>
        <Button onClick={goToSignUp} isWhite label={t('signInView.signUp')} />
      </div>
    </BaseLayout>
  );
};
